import memoize from 'lodash/memoize'

import { captureException } from '../sentry-config'

export const SET_VISIBLE_ACCOUNTS = 'accounts/SET_VISIBLE_ACCOUNTS'

const initialState = {
  visible: [],
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_VISIBLE_ACCOUNTS:
      return {
        ...state,
        visible: action.payload,
      }
    default:
      return state
  }
}

export const setVisibleAccounts = accounts => ({
  type: SET_VISIBLE_ACCOUNTS,
  payload: accounts,
})

export const getVisibleAccounts = () => async (dispatch, getState, { gateway }) => {
  try {
    dispatch(setVisibleAccounts(await gateway.accounts.visible()))
  } catch (e) {
    captureException(e)
  }
}

const getAssignableAccounts = memoize(visibleAccounts =>
  visibleAccounts.filter(account => account.active && account.seat_type !== 'lite')
)

export const getAssignableAccountsSelector = state => getAssignableAccounts(state.accounts.visible)
